export const QURLI_SURVEYS = ["nv142", "nv143", "nv144"]

export const generateAppsFlyerLink = (
  surveyId: string,
  stripe?: boolean,
  params?: { expName?: string; variantName?: string },
) => {
  const isQurli = QURLI_SURVEYS.includes(surveyId)
  const baseUrl = isQurli
    ? "https://qurli.onelink.me/MxWy"
    : "https://pureapp.onelink.me/M5p9"
  const searchParams = new URL(location.href).searchParams
  const destinationUrl = new URL(baseUrl)

  const source =
    searchParams.get("pid") || searchParams.get("utm_source") || "Webfunnel"
  const campaign =
    searchParams.get("c") || searchParams.get("utm_campaign") || surveyId
  const adset = searchParams.get("af_adset")
  const adname = searchParams.get("af_ad")
  const ScCid = searchParams.get("ScCid")
  const gclidUrl = searchParams.get("gclid")
  const af_c_id = searchParams.get("af_c_id")
  const af_adset_id = searchParams.get("af_adset_id")
  const af_ad_id = searchParams.get("af_ad_id")

  const cookies = document.cookie
    .split("; ")
    .map((element) => element.split("="))
    .reduce<Record<string, string>>((acc, curr) => {
      acc[curr[0]] = curr.slice(1).join("=")
      return acc
    }, {})
  const fbp = cookies["_fbp"]
  const fbc = cookies["_fbc"]
  const gclid = cookies["gclid"]
  const gbraid = cookies["gbraid"]
  const wbraid = cookies["wbraid"]

  destinationUrl.searchParams.append("af_xp", "custom")
  destinationUrl.searchParams.append("pid", source)
  destinationUrl.searchParams.append("c", campaign)

  const expName = params?.expName ?? searchParams.get("af_sub4") ?? undefined
  const variantName =
    params?.variantName ?? searchParams.get("af_sub5") ?? undefined

  if (expName && variantName) {
    destinationUrl.searchParams.append("af_sub4", expName)
    destinationUrl.searchParams.append("af_sub5", variantName)
  }

  if (stripe) {
    const userId = localStorage.getItem("funnel_user_id")

    if (userId) {
      destinationUrl.searchParams.append(
        "deep_link_value",
        "funnel_authorization",
      )
      destinationUrl.searchParams.append("deep_link_sub1", userId)
    }
  }

  if (adset) {
    destinationUrl.searchParams.append("af_adset", adset)
  }

  if (adname) {
    destinationUrl.searchParams.append("af_ad", adname)
  }

  if (af_ad_id) {
    destinationUrl.searchParams.append("af_ad_id", af_ad_id)
  }

  if (af_c_id) {
    destinationUrl.searchParams.append("af_c_id", af_c_id)
  }

  if (af_adset_id) {
    destinationUrl.searchParams.append("af_adset_id", af_adset_id)
  }

  if (source.toLowerCase().includes("fb")) {
    if (fbp) {
      destinationUrl.searchParams.append("af_sub1", fbp)
    }
    if (fbc) {
      destinationUrl.searchParams.append("af_sub2", fbc)
    }
  } else if (source.toLowerCase().includes("googleads")) {
    if (gbraid) {
      destinationUrl.searchParams.append("af_sub1", gbraid)
    }

    if (wbraid) {
      destinationUrl.searchParams.append("af_sub2", wbraid)
    }

    if (gclid || gclidUrl) {
      const value = gclid || gclidUrl || ""
      destinationUrl.searchParams.append("af_sub3", value)
    }
  } else if (source.toLowerCase().includes("snapchat")) {
    if (ScCid) {
      destinationUrl.searchParams.append("af_sub1", ScCid)
    }
  } else if (source.toLowerCase().includes("twitter")) {
    const twclid = searchParams.get("twclid")
    if (twclid) {
      destinationUrl.searchParams.append("af_sub1", twclid)
      // @ts-ignore
      if (window.twq) {
        // @ts-ignore
        window.twq("event", "tw-osen8-ovi1t")
      }
    }
  }

  // @ts-ignore
  if (window.ttq && window.ttq.track) {
    // @ts-ignore
    window.ttq.track("ViewContent")
  }

  if (isQurli) {
    destinationUrl.searchParams.append(
      "af_web_dp",
      "https://play.google.com/store/apps/details?id=app.qurli.android",
    )
  }

  return destinationUrl.href
}

export const applyQurliFavicon = () => {
  const base = process.env.PUBLIC_URL || ""

  document
    .querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]')
    .forEach((link) => link.remove())

  const icons: { rel: string; href: string; type?: string; sizes?: string }[] =
    [
      {
        rel: "icon",
        type: "image/png",
        sizes: "96x96",
        href: `${base}/qurli/favicon-96x96.png`,
      },
      {
        rel: "icon",
        type: "image/svg+xml",
        href: `${base}/qurli/favicon.svg`,
      },
      { rel: "icon", href: `${base}/qurli/favicon.ico` },
      {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: `${base}/qurli/apple-touch-icon.png`,
      },
    ]

  icons.forEach(({ rel, href, type, sizes }) => {
    const link = document.createElement("link")
    link.rel = rel
    link.href = href
    if (type) link.type = type
    if (sizes) link.setAttribute("sizes", sizes)
    document.head.appendChild(link)
  })
}

export const isTestingEnv = () =>
  location.hostname.includes("test") || location.hostname.includes("localhost")

export async function sha256Safe(input: string): Promise<string | null> {
  try {
    if (typeof input !== "string") return null

    const subtle = globalThis.crypto?.subtle
    console.log(subtle)
    if (!subtle) return null

    const data = new TextEncoder().encode(input)
    const hashBuffer = await subtle.digest("SHA-256", data)

    const hashArray = Array.from(new Uint8Array(hashBuffer))
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("")
  } catch {
    return null
  }
}
